// ============================================
// スクロールでフェードインするアニメーション
// ============================================
const fadeInAnimation = () => {

	// 表示時に付与するクラス名
	const toggleClass = 'is-visible';

	// フェードイン対象要素を取得
	const targets = document.querySelectorAll('[data-scroll-animation-target]');

	// IntersectionObserver の監視設定
	const options = {

		// 要素の表示率に応じてコールバックを実行
		threshold: [0, 0.1, 0.2]
	};

	const observer = new IntersectionObserver((entries) => {

		entries.forEach(entry => {

			const target = entry.target;
			const ratio = entry.intersectionRatio;

			// 要素が20%以上表示されたらフェードイン
			if (ratio >= 0.2) {
				target.classList.add(toggleClass);
			}

			// 要素の表示率が5%以下になったらフェードアウト
			if (ratio <= 0.05) {
				target.classList.remove(toggleClass);
			}
		});

	}, options);

	// 各対象要素の監視を開始
	targets.forEach(el => {
		observer.observe(el);
	});
};

export default fadeInAnimation;
